goog.provide("shadow.js.shim.module$$carbon$icons_react$es$DragVertical$default");
shadow.js.shim.module$$carbon$icons_react$es$DragVertical$default = shadow.js.require(362, {}).default;
